import { render, staticRenderFns } from "./OrganizationSpacesCreateModal.vue?vue&type=template&id=eb1dd22a"
import script from "./OrganizationSpacesCreateModal.vue?vue&type=script&lang=js"
export * from "./OrganizationSpacesCreateModal.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSpacesCreateModal.vue?vue&type=style&index=0&id=eb1dd22a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports